// extracted by mini-css-extract-plugin
export default {"button":"signupButton_button__iXTK6","disabled":"signupButton_disabled__r-wlF","spinnerColor":"signupButton_spinnerColor__fZGlK","buttonmargin":"signupButton_buttonmargin__CxEix"};